import { AnimatePresence, motion } from "motion/react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useEffect } from "react";
import { LanguageToggle } from "@/components/LanguageToggle";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { registerAdminPush, refreshAdminPush } from "@/lib/push";

export function AdminLayout() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const isRtl = i18n.language?.startsWith("ar");

  useEffect(() => {
    registerAdminPush();

    const refresh = () => {
      if (document.visibilityState === "visible") refreshAdminPush();
    };
    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("focus", refresh);
    window.addEventListener("online", refresh);
    return () => {
      document.removeEventListener("visibilitychange", refresh);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("online", refresh);
    };
  }, []);

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-surface-container-low">
        <AdminSidebar side={isRtl ? "right" : "left"} />


        <div className="flex min-w-0 flex-1 flex-col">
          <header className="sticky top-0 z-40 flex items-center gap-3 border-b border-outline-variant/30 bg-background/80 px-4 py-3 backdrop-blur-md md:px-6">
            <SidebarTrigger className="text-primary" />
            <span className="text-label-md font-label-md uppercase tracking-[0.22em] text-primary">
              {t("admin.title")}
            </span>
            <div className="ms-auto">
              <LanguageToggle />
            </div>
          </header>

          <main className="min-w-0 flex-1 px-4 py-6 md:px-8 md:py-10">
            <AnimatePresence mode="wait" initial={false}>
              <motion.div
                key={pathname}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                className="mx-auto w-full max-w-[1280px]"
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
